module.exports = __webpack_public_path__ + "static/female_cofounders_logo_white-4049623834a98ad2e2959c85729d140d.svg";